/**
   * @function scrollValToggle
   * @description スクロール量を基準にクラスを着脱する
   * @param {String} targetSelector ターゲットとする一意なセレクタ
   * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
   * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
   * @param {String} toggleClass 切り替えるクラス名
   * @return {Void}
  scrollValToggle('#hogeID', 500, false,'active') // 上辺から500px以上離れていれば.active
  scrollValToggle('#hogeID', 0, 500,'active') // 底辺から500px以上離れていれば.active
  scrollValToggle('#hogeID', 500, 500,'active') // 上辺と底辺から500px以上離れていれば.active

// 特定の要素を超えたら表示したい場合は別途計算する
const mv = document.getElementById('mv')
if (mv) {
  const mvHeight = mv.offsetHeight // MVの高さを計算
  scrollValToggle('#navArea', mvHeight, false, 'active') // MVを越えたら表示
}

  */

const mv = document.getElementById('mv')
if (mv) {
  const mvHeight = mv.offsetHeight // MVの高さを計算
  scrollValToggle('#header', mvHeight, 100, 'show')
  scrollValToggle('#fixTicket', mvHeight, 100, 'show')
} else {
  scrollValToggle('#header', 0, 100, 'show')
}
scrollValToggle('#pageNavBox', 0, 100, 'show')

function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.scrollY // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.scrollHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}
